import React from 'react';
import * as style from '../Hooks/style';
import Conditional from '../Hooks/ConditionalRender';
import targetEarning from '../Images/targetEarning.png';
import revenue from '../Images/revenue.png';
import technology from '../Images/technology.png'

export const Sect2 = ({fref, active2}) => {
  return (
    <style.Section2 ref={fref}>
      <Conditional if={active2 === true}>
        <h1>Experience</h1>
        <section>
          <p className="s2Heading">Target</p>
          <img src={targetEarning} alt="targetEarning" />
          Unable to achieve target earning
        </section>
        <section>
          <p className="s2Heading">Opportunities</p>
          <img src={revenue} alt="revenue" />
          Loss of revenue opportunities due to poor utilization
        </section>
        <section>
          <p className="s2Heading">Technology</p>
          <img src={technology} alt="technology" />
          Technology still slow to process
        </section>
        <p>Getting tired with these pain points?</p>
      </Conditional>
    </style.Section2>
  );
}